module.exports = __webpack_public_path__ + "app-static/img/guide2.d047caee.png";